/**
 * Локализация: русский и английский
 */

export type Lang = 'ru' | 'en';

export const i18n = {
  ru: {
    balance: 'Баланс',
    betAmount: 'Сумма ставки',
    payout: 'Выплата',
    cashout: 'КЭШАУТ',
    spin: 'HOLD TO SPIN',
    partialCashout: 'Снять часть',
    demoMode: 'DEMO MODE',
    help: 'Помощь',
    rules: 'Правила игры',
    rulesText: `Правила игры Nexus:

1. Выберите сумму ставки
2. Нажмите HOLD TO SPIN или Пробел — крутится центральный барабан
3. В центре виден один элемент — результат спина:
   - Красный/зелёный/синий с X — соответствующий круг заполняется множителем X
   - Серый — состояние не меняется
   - Череп — все круги обнуляются, выплата сбрасывается
4. Ставка списывается после каждого спина
5. КЭШАУТ — забрать текущую выплату (Ставка × Множитель)`,
    history: 'История',
    settings: 'Настройки',
    about: 'О игре',
    aboutText: 'Nexus — игра от 3CupsGames\nВерсия 1.0.0',
    bonusRules: 'Бонусная игра',
    bonusRulesText: `Бонусная игра начнется, когда все огненные секции будут заполнены.

Каждый премиальный множитель бонусной игры (x100, x200, x300, x400, x500) имеет одинаковый шанс выпадения.

В конце бонусной игры все огненные секции будут сброшены на начало и ты получишь бонусную выплату вместе с суммой за все обнуленные секции огня (х200).`,
  },
  en: {
    balance: 'Balance',
    betAmount: 'Bet amount',
    payout: 'Payout',
    cashout: 'CASHOUT',
    spin: 'HOLD TO SPIN',
    partialCashout: 'Withdraw part',
    demoMode: 'DEMO MODE',
    help: 'Help',
    rules: 'Game Rules',
    rulesText: `Nexus Game Rules:

1. Choose your bet amount
2. Press HOLD TO SPIN or Space — the central drum spins
3. One element is visible in the center — spin result:
   - Red/green/blue with X — that circle fills with multiplier X
   - Gray — no change
   - Skull — all circles reset, payout resets
4. Bet is deducted after each spin
5. CASHOUT — take current payout (Bet × Multiplier)`,
    history: 'History',
    settings: 'Settings',
    about: 'About',
    aboutText: 'Nexus — game by 3CupsGames\nVersion 1.0.0',
    bonusRules: 'Bonus Game',
    bonusRulesText: `The bonus game will start when all fire sections are filled.

Each premium multiplier of the bonus game (x100, x200, x300, x400, x500) has an equal chance of dropping.

At the end of the bonus game, all fire sections will be reset to the beginning and you will receive the bonus payout along with the sum for all reset fire sections (x200).`,
  },
};

export function getText(lang: Lang, key: keyof typeof i18n.ru): string {
  return i18n[lang][key] || i18n.ru[key];
}
